
import React, { useEffect, useState } from 'react'
import { Paragraph, SectionInfo } from 'types/Challenge'
import Typography from 'Components/Base/Typography'
import Row from 'Components/Base/Row'
import Column from 'Components/Base/Column'
import data from 'tria-ui-react-lib/challenges/stepInfo.json'
import ResponsiveContainer from 'Components/Base/ResponsiveContainer'

interface Props {
  step: number
  setInfoPage: (infoPage: boolean) => void
}
export default function HydrationStep7({ step, setInfoPage }: Props) {
  const [sectionInfo, setSectionInfo] = useState<SectionInfo>()
  const [stepParagraphs, setStepParagraphs] = useState<Paragraph[]>()
  const [isMobile, setIsMobile] = useState<boolean>()

  useEffect(() => {

    window.scrollTo(0, 0)
    setInfoPage(true)
    setSectionInfo(data.pageInfoBySection.sectionInfo.find((sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2])))
    setStepParagraphs(data.pageInfoBySection.sectionInfo.find((sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]))?.paragraphs)
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1200) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    })

    if (window.innerWidth < 1200) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [step])


  return (
    <ResponsiveContainer>
      <Column styles={{ margin: isMobile ? '20px auto' : 'auto 0px' }}>
        <Row styles={{ margin: isMobile ? '20px auto' : '20px 0px' }}>
          <Typography variant='h1'>{sectionInfo?.titles.find((title) => title.titleId === 9)?.titleText ?? ''}</Typography>
        </Row>
        <ol>
          <li style={{ fontFamily: 'Raleway', marginBottom: 10, fontSize: 20 }}><i>{sectionInfo?.titles.find((title) => title.titleId === 10)?.titleText ?? ''}</i> {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 35)?.paragraph ?? ''}</li>
          <li style={{ fontFamily: 'Raleway', marginBottom: 10, fontSize: 20 }}><i>{sectionInfo?.titles.find((title) => title.titleId === 11)?.titleText ?? ''}</i> {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 36)?.paragraph ?? ''}</li>
          <li style={{ fontFamily: 'Raleway', marginBottom: 10, fontSize: 20 }}><i>{sectionInfo?.titles.find((title) => title.titleId === 12)?.titleText ?? ''}</i> {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 37)?.paragraph ?? ''}</li>
          <li style={{ fontFamily: 'Raleway', marginBottom: 10, fontSize: 20 }}><i>{sectionInfo?.titles.find((title) => title.titleId === 13)?.titleText ?? ''}</i> {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 38)?.paragraph ?? ''}</li>
          <li style={{ fontFamily: 'Raleway', marginBottom: 10, fontSize: 20 }}><i>{sectionInfo?.titles.find((title) => title.titleId === 14)?.titleText ?? ''}</i> {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 39)?.paragraph ?? ''}</li>
          <li style={{ fontFamily: 'Raleway', marginBottom: 10, fontSize: 20 }}><i>{sectionInfo?.titles.find((title) => title.titleId === 15)?.titleText ?? ''}</i></li>

        </ol>
      </Column>
      <Column styles={{ width: '100%' }}>
        <Row>
          <Column>
            <img src={sectionInfo?.images.find((image) => image.imageId === 7)?.url} alt='scale' style={{ width: isMobile ? '100%' : '60%', marginLeft: 'auto', border: '1px solid black', marginBottom: 20 }} />
            <img src={sectionInfo?.images.find((image) => image.imageId === 8)?.url} alt='scale' style={{ width: isMobile ? '100%' : '60%', marginLeft: 'auto', border: '1px solid black', marginBottom: 20 }} />
            <img src={sectionInfo?.images.find((image) => image.imageId === 9)?.url} alt='scale' style={{ width: isMobile ? '100%' : '60%', marginLeft: 'auto', border: '1px solid black', marginBottom: 20 }} />
          </Column>
          <Column>
            <img src={sectionInfo?.images.find((image) => image.imageId === 11)?.url} alt='scale' style={{ width: isMobile ? '100%' : '60%', marginLeft: 'auto', border: '1px solid black', marginBottom: 20 }} />
            <img src={sectionInfo?.images.find((image) => image.imageId === 10)?.url} alt='scale' style={{ width: isMobile ? '100%' : '60%', marginLeft: 'auto', border: '1px solid black', marginBottom: 20 }} />
            <img src={sectionInfo?.images.find((image) => image.imageId === 12)?.url} alt='scale' style={{ width: isMobile ? '100%' : '60%', marginLeft: 'auto', border: '1px solid black', marginBottom: 20 }} />
          </Column>
        </Row>
      </Column>
    </ResponsiveContainer>
  )
}

